<template>
  <div>
    <Modal
      v-model="modalShow"
      :title="title"
      footer-hide
      width="1000"
      class-name="no-adding-modal">
      <codemirror ref="showCm" v-model="content" :options="showCmOptions"></codemirror>
    </Modal>
  </div>
</template>

<script>
import { scriptTypeChange } from './scriptTools'
import codemirror from './scriptUse.js'

export default {
  name: 'script-show',
  components: {
    codemirror
  },
  data () {
    return {
      modalShow: false,
      title: '脚本',
      content: '',
      showCmOptions: {
        mode: {
          name: 'shell'
        },
        lineNumbers: false,
        styleActiveLine: true,
        indentUnit: 4,
        lineWrapping: true,
        theme: 'monokai',
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        height: '600px',
        readOnly: true,
        showCursorWhenSelecting: true,
        gutters: ['CodeMirror-linenumbers']
      }
    }
  },
  computed: {
    myCodeMirror () {
      let editor = this.$refs.showCm.editor
      editor.setSize('100%', 600)
      editor.refresh()
      return editor
    }
  },
  methods: {
    openModal (data, versionView = true, onlyView = false) {
      if (!data) {
        this.$Notice.warning({ title: '无数据' })
        return false
      }
      if (!onlyView) {
        if (versionView) {
          if (!data.script) {
            this.$Notice.warning({ title: '无数据' })
            return false
          }
          this.title = '脚本名: ' + data.script.name + ' & 脚本类型: ' + data.type +
            ' & 版本号: ' + data.version_id + ' & 创建用户: ' + data.user_full_name
        } else {
          this.title = '脚本名: ' + data.name + ' & 脚本类型: ' + data.type
        }
      } else {
        this.title = '脚本类型: ' + data.type
      }
      this.content = data.content
      this.typeChange(data.type)
      this.modalShow = true
    },
    typeChange (value) {
      const lang = scriptTypeChange(value)
      this.myCodeMirror.setOption('mode', { name: lang })
    }
  }
}
</script>

<style lang="less">
  @import './base.less';
  .ivu-poptip-body {
    text-align: left !important;
  }
  .CodeMirror{
    font-size: 15px;
  }
  .CodeMirror-fullscreen {
    z-index: 999 !important;
  }
  .CodeMirror-hints {
    z-index: 1000 !important;
  }
  .no-adding-modal .ivu-modal-body {
    padding: 0;
  }
</style>
